import { useEffect, useMemo, useRef } from 'react'
import { connect } from 'react-redux'
import {
  STATIC_NAV_ENTRIES,
  buildDynamicNavigationEntries,
  buildNavigationMiniSearchIndex,
  searchNavigationMiniSearch,
} from '../local/navigationRegistry'

/**
 * BM25 counterpart of NavigationSearchProvider. Runs the same navigation
 * registry through a MiniSearch index and routes results to
 * SupplementarySearchContext under providerId='navigation-minisearch'.
 *
 * Both engines always run; SearchProviderContainer's presentationEngine decides
 * which one consumers present. The non-presented engine still feeds the
 * search-quality report.
 */
function NavigationMiniSearchProvider({
  query, options, onResults,
  sections,
}) {
  const entries = useMemo(
    () => STATIC_NAV_ENTRIES.concat(
      buildDynamicNavigationEntries({ sections }),
    ),
    [sections],
  )

  const ms = useMemo(() => buildNavigationMiniSearchIndex(entries), [entries])

  const onResultsRef = useRef(onResults)
  onResultsRef.current = onResults

  useEffect(() => {
    if (!query) {
      onResultsRef.current({ hits: [] })
      return
    }
    const limit = options && options.hitsPerPage ? options.hitsPerPage : 8
    const hits = searchNavigationMiniSearch(ms, entries, query, limit)
    onResultsRef.current({ hits })
  }, [query, ms, entries, options])

  return null
}

function mapStateToProps(state) {
  return {
    sections: state.sections,
  }
}

export default connect(mapStateToProps)(NavigationMiniSearchProvider)
